import { Button, Tag } from "@rio-cloud/rio-uikit";
import { IContractDetailsVolksEssential } from "../../../../models/volksPlanEssential";
import { Card } from "@mui/material";
import { useIntl } from "react-intl";
import { Asset } from "../../../../models/asset";

export interface IRevisionsProps {
  volksEssentialPlan?: IContractDetailsVolksEssential | null;
  hasGroup?: boolean;
  setMaintenanceGroupSidebarAsset?: React.Dispatch<React.SetStateAction<Asset | null>>
  setShowMaintenanceGroupSidebarDialog?: React.Dispatch<React.SetStateAction<boolean>>
  asset: Asset
  closeModal: () => void
}

const Revisions = ({ volksEssentialPlan, hasGroup, setMaintenanceGroupSidebarAsset, setShowMaintenanceGroupSidebarDialog, asset, closeModal }: IRevisionsProps) => {

  const goToGroupMaintenance = () => {
    setMaintenanceGroupSidebarAsset?.(asset)
    closeModal()
    setShowMaintenanceGroupSidebarDialog?.(true)
  }

  const intl = useIntl();

  return (
    <>
      {!volksEssentialPlan?.revision.length ? (
        <div className="flex items-center gap-10 bg-[#F9FAFB] p-4 rounded-lg">
          <img src="/assets/images/settingsicon.png" alt="Revisões" className="w-[26px] h-[26px]" />
          <div>
            <p className="text-[#2A3740] font-semibold text-2xl m-0">Não há manutenções definidas</p>
            <p className="">Para geração das revisões da garantia, defina aqui no Monitor de Manutenção e Reparo o grupo de manutenção do veículo.</p>
          </div>
          {hasGroup ? null : (
            <Button
              className="btn w-[300px]"
              onClick={goToGroupMaintenance}
            >
              Editar grupo de manutenção 
            </Button>
          )}
        </div>
      ) : null}

      {volksEssentialPlan?.revision.length ? (
        volksEssentialPlan?.revision.map((revision, index) => (
          <div className="flex flex-col gap-4 w-full">
            <Card className="flex flex-col w-full margin-bottom-10">
              <div
                className="flex items-center gap-12 px-10 py-8 bg-[#F9FAFB] min-h-[56px]"
              >
                <p className="text-1xl font-semibold text-gray-800 whitespace-nowrap">
                    {index + 1}ª {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.maintenance" })}
                </p>

                <p className="text-1xl font-medium text-gray-800 m-0 whitespace-nowrap overflow-hidden text-ellipsis">
                    {revision.name}
                </p>

                <div className="flex items-center gap-4">
                  {
                    revision.available ?
                      <Tag icon='rioglyph rioglyph-ok' size="small">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.performedAvailable" })}</Tag> :
                      <Tag icon='rioglyph rioglyph-ok' size="small" className="available-tag">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.performedSwap" })}</Tag>
                  }
                  <span className="rioglyph rioglyph-info-sign ml-2 text-[#2A37403D] text-4xl"></span>
                </div>
              </div>
            </Card>
          </div>
        ))
      ) : null }
    </>
  );
};

export default Revisions;
